import React from 'react';

function PrivacyComp() {
  const privacyPolicyData = [
    {
      heading: "Information We Collect",
      points: [
        "Contact information: Name, email, phone number",
        "Payment details (secured and encrypted)",
        "Location data (when using location services)",
        "Browsing behavior on our website/app (via cookies and analytics tools)",
      ],
    },
    {
      heading: "How We Use Your Information",
      points: [
        "To provide access to our platform and bidding features",
        "To process transactions and issue receipts",
        "For customer service and communication",
        "For fraud prevention, authentication, and compliance with legal obligations",
        "To personalize your experience and offer relevant auctions or services",
      ],
    },
    {
      heading: "Data Sharing",
      paragraph:
        "We do not sell, rent, or trade your personal information. We may share your data with:",
      points: [
        "Trusted third-party vendors for payment processing, shipping, and analytics",
        "Law enforcement or regulatory authorities if required by law",
      ],
    },
    {
      heading: "Data Retention",
      paragraph:
        "We retain personal information as long as necessary to fulfil services and legal obligations. You may request deletion of your account and associated data at any time, subject to transaction record retention policies.",
    },
    {
      heading: "Your Rights",
      points: [
        "Request access to your personal data",
        "Request correction or deletion of data",
        "Opt-out of marketing communications",
        "File a complaint with a data protection authority",
      ],
    },
    {
      heading: "Security Measures",
      points: [
        "SSL encryption for all data transmissions",
        "Secure servers and regular audits",
        "Role-based access controls for sensitive information",
      ],
    },
    {
      heading: "Contact",
      paragraph:
        "For any privacy-related concerns, please contact: privacy@anachronisticauction.com",
    },
  ];
  return (
  
     <section className="sec_pd mb-5 mt-5">
       <h3 className="text-black mb-4">Privacy Policy</h3>
     {privacyPolicyData.map((section, idx) => (
       <div key={idx} className="mb-4">
         <p className="text-black fw-bold mt-4">{idx + 1}. {section.heading}</p>
         
         {section.paragraph && (
           <p className="text-muted">{section.paragraph}</p>
         )}

         {section.points && (
           <ul className="text-muted list-disc list-inside ml-4 mt-2">
             {section.points.map((point, i) => (
               <li key={i}>{point}</li>
             ))}
           </ul>
         )}
       </div>
     ))}
   </section>
  );
}

export default PrivacyComp;
